var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flexwrap centercenter",staticStyle:{"width":"100%","height":"100%"}},[_c('div',{staticClass:"container flexwrap centercenter"},[_c('div',{staticClass:"loadingLogo",style:({ backgroundImage: 'url(' + require('../assets/logo_small.png')+ ')' })})])])
}
var staticRenderFns = []

export { render, staticRenderFns }